import { render } from "./SocialTemplates.vue?vue&type=template&id=65f899bb"
import script from "./SocialTemplates.vue?vue&type=script&lang=js"
export * from "./SocialTemplates.vue?vue&type=script&lang=js"

import exportComponent from "/trc/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__